const state = {
};

const getters = {
};

const actions = {
    async getTree({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/contracts/${params.contract_id}/tree-nature-feedback/${params.id}`)
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getItem({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/contracts/${params.contract_id}/nature-feedback/${params.id}`)
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async saveItem({ commit }, params) {
        let method = "POST";
        let api    = `api/contracts/${params.contract_id}/nature-feedback`;
        if(params.id) {
            method = "PUT";
            api   += `/${params.id}`;
        }

        return new Promise((resolve, reject) => {
            global.axios(api, {
                method: method,
                data: params,
                headers: {
                    Accept: "application/json",
                },
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    
    async deteleItem({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/contracts/${params.contract_id}/nature-feedback/${params.id}`)
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        });
    },

    // Case requestor type
    async getListCaseRequestorTypes({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/case-requestor-types`, {
                params: params
            }).then(response => {
                resolve(response.data.data);
            }).catch(error => reject(error));
        });
    },
    async getItemCaseRequestorTypes({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/case-requestor-types/${params}`)
            .then(response => {
                resolve(response);
            }).catch(error => reject(error));
        });
    },
    async createItemCaseRequestorTypes({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/case-requestor-types`,params)
            .then(response => {
                resolve(response);
            }).catch(error => reject(error));
        });
    },
    async updateItemCaseRequestorTypes({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.put(`api/case-requestor-types/${params.id}`,params)
            .then(response => {
                resolve(response);
            }).catch(error => reject(error));
        });
    },
    async deteleItemCaseRequestorTypes({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/case-requestor-types`,{
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        });
    },
    async cloneMasterCaseRequestorTypes({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/case-requestor-types/clone`, {
                method: "POST",
                data: params
            }).then(response => {
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });
    },

    // Custom fields
    async saveCaseSettingCustomFields({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/case-settings/custom-field`, params)
            .then(response => {
                resolve(response);
            }).catch(error => reject(error));
        });
    },
    async importCaseSettingCustomFields({ commit }, params) {
        let formData = new FormData();
        formData.append('file_import', params.fileImport);
        formData.append('contract_id', params.contract_id);
        return new Promise((resolve, reject) => {
            global.axios.post(`api/case-settings/custom-field/import`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        });
    },

    // Case Email Default Filter
    async getListEmailDefaultFilters({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/email-default-filters`, {
                params: params
            }).then(response => {
                resolve(response.data.data);
            }).catch(error => reject(error));
        });
    },
    async getDetailEmailDefaultFilters({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/email-default-filters/${params.id}`).then(response => {
                resolve(response.data.data);
            }).catch(error => reject(error));
        });
    },
    async getEachUserEmailDefaultFilters({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/email-default-filters/each_user/${params.email}`).then(response => {
                resolve(response.data.data);
            }).catch(error => reject(error));
        });
    },
    async getNltCsoUserEmailDefaultFilters({ commit },params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/email-default-filters/user/cso/${params.email_id}`,{params:params}).then(response => {
                resolve(response.data.data);
            }).catch(error => reject(error));
        });
    },
    async createItemEmailDefaultFilters({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/email-default-filters`,params)
            .then(response => {
                resolve(response);
            }).catch(error => reject(error));
        });
    },
    // Case Email Status
    async getListCaseEmailStatus({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/case-email-status`, {
                params: params
            }).then(response => {
                resolve(response.data.data);
            }).catch(error => reject(error));
        });
    },
    async getUniqueListCaseEmailStatus({ commit },params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/case-email-status/unique_list/${params.email_id}`).then(response => {
                resolve(response.data.data);
            }).catch(error => reject(error));
        });
    },

    async createItemCaseEmailStatus({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/case-email-status`,params)
            .then(response => {
                resolve(response);
            }).catch(error => reject(error));
        });
    },
    async updateItemCaseEmailStatus({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.put(`api/case-email-status/${params.id}`,params)
            .then(response => {
                resolve(response);
            }).catch(error => reject(error));
        });
    },
    async deleteItemCaseEmailStatus({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/case-email-status`,{
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve(response);
            }).catch(error => reject(error));
        });
    },

     // Case requestor company
     async getListCaseRequestorCompany({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/case-requestor-companies`, {
                params: params
            }).then(response => {
                resolve(response.data.data);
            }).catch(error => reject(error));
        });
    },
    async getItemCaseRequestorCompany({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/case-requestor-companies/${params}`)
            .then(response => {
                resolve(response);
            }).catch(error => reject(error));
        });
    },
    async createItemCaseRequestorCompany({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/case-requestor-companies`,params)
            .then(response => {
                resolve(response);
            }).catch(error => reject(error));
        });
    },
    async updateItemCaseRequestorCompany({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.put(`api/case-requestor-companies/${params.id}`,params)
            .then(response => {
                resolve(response);
            }).catch(error => reject(error));
        });
    },
    async deteleItemCaseRequestorCompany({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/case-requestor-companies`,{
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        });
    },

    // PIC Role Mapping
    async getItemPICRoleMapping({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/contract-setting-role-mapping`, {
                params: params
            })
            .then(response => {
                resolve(response.data.data);
            }).catch(error => reject(error));
        });
    },
    async createItemPICRoleMapping({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/contract-setting-role-mapping`,params)
            .then(response => {
                resolve(response);
            }).catch(error => reject(error));
        });
    },
    async updateItemPICRoleMapping({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.put(`api/contract-setting-role-mapping/${params.id}`,params)
            .then(response => {
                resolve(response);
            }).catch(error => reject(error));
        });
    },
    async deteleItemPICRoleMapping({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/contract-setting-role-mapping`,{
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        });
    },
};

const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}